export default __webpack_public_path__ + "static/media/brandGif.6d1b674a.gif";